import { PowerOff, X, ChevronRight } from 'lucide-react';
import logo from '../../logo.png';
import { CATEGORIAS } from './menus';

export default function Sidebar({ isOpen, onClose, user, navItems, rol, location, onNav, onLogout }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex animate-fade-in"
      onClick={onClose}>
      <aside className="w-full max-w-sm h-full flex flex-col shadow-2xl animate-slide-in bg-guinda-900"
        onClick={e => e.stopPropagation()}>

        {/* Header sidebar */}
        <div className="flex items-center justify-between px-5 py-5 border-b border-white/10">
          <img src={logo} alt="DOMINIUM" className="h-14 object-contain drop-shadow-[0_2px_10px_rgba(255,255,255,0.45)]" />
          <button onClick={onClose}
            className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition text-white">
            <X size={20} />
          </button>
        </div>

        {/* Info usuario */}
        <div className="px-5 py-4 border-b border-white/10 flex items-center gap-3">
          <div className="w-11 h-11 rounded-full bg-gradient-to-br from-guinda-400 to-guinda-700 flex items-center justify-center text-white font-bold text-base flex-shrink-0 ring-2 ring-white/20">
            {user?.nombre?.[0]?.toUpperCase() || 'U'}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-white font-semibold text-sm truncate">{user?.nombre} {user?.apellido_paterno}</p>
            <p className="text-guinda-200 text-xs capitalize truncate">{rol?.replace(/_/g, ' ')}</p>
          </div>
        </div>

        {/* Módulos agrupados */}
        <nav className="flex-1 px-3 py-4 overflow-y-auto">
          {CATEGORIAS.map(cat => {
            const items = navItems.filter(i => i.cat === cat.key);
            if (items.length === 0) return null;
            return (
              <div key={cat.key} className="mb-5">
                <p className="px-3 mb-2 text-[10px] font-bold text-white/40 uppercase tracking-widest">
                  {cat.label}
                </p>
                <div className="flex flex-col gap-1">
                  {items.map(item => {
                    const isActive = location.pathname === item.path;
                    const Icon = item.icon;
                    return (
                      <button key={item.path} onClick={() => onNav(item.path)}
                        className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-left text-sm font-medium transition-all ${
                          isActive
                            ? 'bg-white text-guinda-800 shadow-lg'
                            : 'text-white/85 hover:bg-white/10 hover:text-white'
                        }`}>
                        <Icon size={18} className={isActive ? 'text-guinda-700' : 'text-white/70'} />
                        <span className="flex-1 truncate">{item.label}</span>
                        {isActive && <ChevronRight size={14} className="text-guinda-700" />}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="px-3 py-4 border-t border-white/10">
          <button onClick={onLogout}
            className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-white/80 hover:bg-red-500/20 hover:text-white transition w-full text-sm font-medium">
            <PowerOff size={16} />
            Cerrar sesión
          </button>
        </div>
      </aside>
    </div>
  );
}
